











import Vue from 'vue';

export default Vue.extend({
    name: 'NotFound',
    computed: {
        url() {
            const rawUrl = this.$route.redirectedFrom as string;
            if (rawUrl !== undefined) {
                return decodeURIComponent(rawUrl);
            } else {
                return '';
            }
        }
    }
});
